import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class NaturalLightIndoorTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "varBPSColumn", title: "Eingestellte variable Bitrate" },
        { name: "observedBPSColumn", title: "Resultierende Bitrate" }
      ],
      rows: [
        { varBPSColumn: '5120 kbps', observedBPSColumn: '4.45 Mbit/s' },
        { varBPSColumn: '2560 kbps', observedBPSColumn: '2.38 Mbit/s' },
        { varBPSColumn: '2240 kbps', observedBPSColumn: '1.98 Mbit/s' },
        { varBPSColumn: '1920 kbps', observedBPSColumn: '1.97 Mbit/s' },
        { varBPSColumn: '1600 kbps', observedBPSColumn: '1.70 Mbit/s' },
        { varBPSColumn: '1280 kbps', observedBPSColumn: '1.32 Mbit/s' },
        { varBPSColumn: '640 kbps', observedBPSColumn: '682 kbit/s' },
        { varBPSColumn: '320 kbps', observedBPSColumn: '390 kbit/s' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

NaturalLightIndoorTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(NaturalLightIndoorTable)
